import React from 'react';

import { STATIC_PATH } from 'constants';

const Logo = (props) => {
  return (
    <img
      alt="RedShelf"
      src={`${STATIC_PATH}/images/redshelf-logo.svg`}
      {...props}
    />
  );
};

export default Logo;
